import React from 'react';
const benefits = [{
  bold: 'Sin inversión inicial:',
  text: 'Cobrá ANTES de gastar. Usá el dinero de tus clientes para financiar la compra de insumos. 💰'
}, {
  bold: 'Sin descuidar a tus hijos:',
  text: 'Negocio 100% desde casa que se adapta a tus tiempos y no al revés. Mamá presente y productiva. 👩‍👧‍👦'
}, {
  bold: 'Sin depender de jefes ni horarios ajenos:',
  text: 'Vos sos la dueña. Manejá tu agenda y decidí cuánto querés ganar cada mes. 🚀'
}, {
  bold: 'Sin improvisar precios ni "trabajar gratis":',
  text: 'Profesionalizá tu cocina con costos exactos y márgenes de ganancia asegurados. 📊'
}];
export function NewRealitySection() {
  return <section className="w-full bg-[#f0efe9] px-4 md:px-8" data-id="element-227">
      {/* Down Arrows */}
      <div className="flex justify-center gap-1 pt-2 pb-8 text-3xl" data-id="element-228">
        <span className="text-[#e6a817]" data-id="element-229">⬇️</span>
        <span className="text-[#e6a817]" data-id="element-230">⬇️</span>
        <span className="text-[#e6a817]" data-id="element-231">⬇️</span>
      </div>

      <div className="max-w-[900px] mx-auto pb-20" data-id="element-232">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)] overflow-hidden" data-id="element-233">
          {/* Header */}
          <div className="text-center py-6 px-6 border-b border-gray-100" data-id="element-234">
            <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[34px] font-bold text-[#1a1a1a]" data-id="element-235">
              ⭐ Tu nueva realidad con este sistema...
            </h2>
          </div>

          {/* Benefits */}
          <div className="px-6 md:px-10 py-8 space-y-7" data-id="element-236">
            {benefits.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-237">
                {/* Green check icon */}
                <div className="flex-shrink-0 mt-1" data-id="element-238">
                  <div className="w-7 h-7 rounded-full bg-[#2d6a2e] flex items-center justify-center" data-id="element-239">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" data-id="element-240">
                      <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-241" />
                    </svg>
                  </div>
                </div>
                {/* Text */}
                <p className="font-['Montserrat',_sans-serif] text-[#374151] text-base md:text-lg lg:text-[19px] leading-relaxed" data-id="element-242">
                  <span className="font-bold text-[#1a1a1a]" data-id="element-243">{point.bold}</span>{' '}
                  {point.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>

      {/* Plan Section */}
      <div className="w-full bg-[#f9f8f4] pt-12 pb-4" data-id="element-244">
        <div className="max-w-[900px] mx-auto text-center px-4" data-id="element-245">
          <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-[42px] font-bold text-[#1a1a1a] leading-tight" data-id="element-246">
            El Plan de Ejecución para Facturar en Serio (Sin humo)
          </h2>
          <div className="w-16 h-1 bg-[#2d6a2e] mx-auto mt-4" data-id="element-247"></div>

          {/* Subtitle */}
          <p className="font-['Montserrat',_sans-serif] text-[#555] text-lg md:text-xl lg:text-[22px] leading-relaxed mt-6 mb-8" data-id="element-248">
            Olvídate de "subir fotitos y rezar". Acá vas a instalar un{' '}
            <span className="font-bold text-[#1a1a1a]" data-id="element-249">
              sistema de adquisición de clientes
            </span>{' '}
            y una cadena de producción eficiente.
          </p>

          {/* Pill Badge */}
          <div className="inline-block bg-[#1e2330] rounded-full py-3 px-6 md:px-10 mb-10" data-id="element-250">
            <p className="font-['Montserrat',_sans-serif] text-[#facc15] font-bold text-base md:text-lg" data-id="element-251">
              👇 Tu hoja de ruta de 4 semanas hacia la rentabilidad:
            </p>
          </div>
        </div>

        {/* Product Image - wider, no borders */}
        <div className="max-w-[1000px] mx-auto px-4" data-id="element-252">
          <img src="https://cdn.magicpatterns.com/uploads/uSeX1kMNJWvrS7H8tH14sz/Captura_de_pantalla_2026-04-30_a_las_6.35.23_p._m..png" alt="Viandas Rentables - Sistema completo de negocio" className="w-full h-auto" data-id="element-253" />
        </div>
      </div>
    </section>;
}